import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import { LONG_FULL_DATE_FORMAT } from '@/helpers/constants';
import { getFullFormattedDate } from '@/helpers/utils';
import { getSettingsInfo } from '@/redux/User/user.reducer';
import styles from './Feedback.module.scss';

interface TimeWithDateProps {
  title: string;
  date: string;
  timeZone: string;
}

const TitleWithDate: React.FC<TimeWithDateProps> = (props) => {
  const { title, date, timeZone } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.TitleSection}>
      <h3>{title}</h3>
      {date
        ? (
          <div>
            <TooltipComponent title={t('feedback.lastUpdatedAt')}>
              <div>
                <i className={`di icon-uhr-check ${styles.IconDate}`} />
              </div>
            </TooltipComponent>
            <span>{getFullFormattedDate(date, timeZone, LONG_FULL_DATE_FORMAT)}</span>
          </div>
        )
        : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  timeZone: getSettingsInfo(state)?.timezone,
});

export default connect(mapStateToProps)(TitleWithDate);
